import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import LoginService from "./loginService";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import { Paper } from '@mui/material';
import Button from '@mui/material/Button';
//import {useDispatch} from "react-redux";
import { myroutes } from "../../routes/webroute";
import { useNavigate } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Swal from "sweetalert2";
import { checkAuthenticate, loginUser } from "../app/providers/authSlice";
import { useDispatch, useSelector } from "react-redux";


export default function Login() {

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    useEffect(() => { 
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.dashboard)
            console.log("is authenticate "+isAuthenticated)
        }else{
            console.log("not authenticate "+isAuthenticated)
        }
    
        
    }, [dispatch,isAuthenticated])



    const handleLogin = async (event) => {
        event.preventDefault()
        let form = { username, password }

        await LoginService.login(form).then((response) => {
            //console.log(response.status)
            // Effectuer des vérifications et appeler l'action de connexion
            if (response.status === 200) {
                //console.log("response spring boot : "+ response.data.userDTO.id)
                //console.log("response spring boot : "+ response.data.userDTO.username)
                //localStorage.setItem('userDTO', JSON.stringify(response.data.userDTO));
                dispatch(loginUser(response.data));
                dispatch(checkAuthenticate());
              
            }

        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error,
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                background: "red",
                color: "white",
                iconColor: "white"
            })
            //console.log(error)
        })
    }


    useEffect(() => { 
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
       if (isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.dashboard)
            //console.log("is authenticate "+isAuthenticated)
        }else{
            navigate(myroutes.login)
            //console.log("not authenticate "+isAuthenticated)
        }
    
        
    }, [isAuthenticated, dispatch])

    return (
        <React.Fragment>
            {/* Content */}
            <div className="login-background">
                <Container>
                    <div className="centered-form">
                        <Paper
                            elevation={3}
                            style={{
                                padding: "50px 20px",
                                width: "600px",
                                margin: "20px auto",
                                backgroundColor: "",
                            }}
                        >
                            <div className="text-center">
                                <Link className="">
                                    <span className=""></span>
                                    <span
                                        className="fw-bold"
                                        style={{ color: "black", fontSize: "24px" }}
                                    >
                                        <img
                                            src="/images/logo_gs_sans_fond.png"
                                            className="img-fluid"
                                            alt="Login image"
                                            width="100"
                                        />
                                        <br />
                                        Bienvenue sur Schoolarys ! 👋
                                    </span>
                                </Link>
                            </div>
                            <Box
                                sx={{
                                    "& > :not(style)": { m: 1, width: "58ch" },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <form
                                    id="formAuthentication"
                                    className="mb-3"
                                    onSubmit={handleLogin}
                                >
                                    <TextField
                                        id="outlined-basic-email"
                                        name="email-username"
                                        label="Email"
                                        variant="outlined"
                                        fullWidth
                                        style={{ marginBottom: "30px", marginTop: "30px" }}
                                        required={true}
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: { marginBottom: "10px" }
                                        }}
                                    />

                                    <TextField
                                        id="outlined-basic-password"
                                        name="password"
                                        label="Password"
                                        variant="outlined"
                                        fullWidth
                                        style={{ marginBottom: "30px" }}
                                        required={true}
                                        value={password}
                                        type={showPassword ? "text" : "password"}
                                        placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                        onChange={(e) => setPassword(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: { marginBottom: "10px" }
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={togglePasswordVisibility}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                    <div className="d-flex justify-content-between fw-bold">
                                        <Link>
                                            <small style={{ color: "#FDA639" }}>
                                                Mot de passe oublié?
                                            </small>
                                        </Link>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="remember-me"
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="remember-me"
                                            >
                                                Se rappeler de moi
                                            </label>
                                        </div>
                                    </div>
                                    <Button
                                        variant="outlined"
                                        type="submit"
                                        fullWidth
                                        style={{ marginTop: "30px" }}
                                    >
                                        Se connecter
                                    </Button>
                                </form>
                            </Box>
                        </Paper>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
}